export default "__VITE_ASSET__Cug93964__"